import React from 'react'

import MenuBookIcon from '@mui/icons-material/MenuBook'

import { BookCardStyle } from '../styles'
import { openLibraryCover } from '../../utils/bookCover'
import BookModal from '../modals/BookModal'
import ResourceCard from './ResourceCard'
import { openExternal } from '../../utils/safeUrl'

const BookCard = (props) => {
    const openResource = () => {
        openExternal(props.link)
        return false;
    }

    return (
        <ResourceCard
            Icon={MenuBookIcon}
            cardStyle={BookCardStyle}
            modal={<BookModal {...props} />}
            title={props.title}
            description={props.description}
            thumbnail={openLibraryCover(props.isbn) ?? undefined}
            date={props.pub_date}
            content_tags={props.content_tags}
            medical_specialty_tags={props.medical_specialty_tags}
            is_seminal_work={props.is_seminal_work || props.seminal_work}
            onOpen={openResource}
        />
    )
}

export default BookCard
